function showRecoverPasswordForm() {
  document.getElementById('customer-recover-password').style.display = 'block';
  document.getElementById('customer-login').style.display='none';
}
function hideRecoverPasswordForm() {
  document.getElementById('customer-recover-password').style.display = 'none';
  document.getElementById('customer-login').style.display = 'block';
}
if (window.location.hash == '#recover') { 
  showRecoverPasswordForm() 
  var form = document.querySelector('#customer-recover-password form');
  if (form.querySelector(".errors")) {
    var errorMsg = form.querySelector(".errors");
    if (errorMsg.querySelector("li").innerText.indexOf("No account found with that email.") != -1) {
      errorMsg.querySelector("li").innerHTML = "No account found. If you registered but haven't verified your account, <a href='/account/register'>click here</a> to re-verify.";
    }
  }
  
}

document.querySelectorAll('.customer-form-page form').forEach((form)=>{
  form.addEventListener('submit', (e)=>{
    var error = false;
    form.querySelectorAll('.error').forEach((element)=>{
      element.classList.remove('error');
    });
    form.querySelectorAll('.required').forEach((element)=>{
      if(element.value=="") {
        error = true;
        element.classList.add('error');
        form.querySelector('.error-msg').innerHTML = 'Please complete all the required fields.';
      }
    });
    if(!error && form.querySelector('.email')) {
      if(!$s.validateEmail(form.querySelector('.email').value)) {
        error = true;
        form.querySelector('.email').classList.add('error');
        form.querySelector('.error-msg').innerHTML = 'Please enter a valid email address.';
      }
    }
    if(!error && form.querySelector('[name="customer[password_confirmation]"]')) {
      if(form.querySelector('[name="customer[password]"]').value != form.querySelector('[name="customer[password_confirmation]"]').value) {
        error = true;
        form.querySelector('[name="customer[password_confirmation]"]').classList.add('error');
        form.querySelector('.error-msg').innerHTML = 'The password must match with its confirmation.';
      }
    }
    if(error) {
      e.preventDefault();
      e.stopImmediatePropagation();
      form.querySelector('.error-msg').style.display = 'block';
      return false;
    }
  });
});